import messages from "@smartmixin/i18n/dist/translations/ja.json";

export default messages;
